import { render, staticRenderFns } from "./ComposerBox.vue?vue&type=template&id=476087ac&"
import script from "./ComposerBox.vue?vue&type=script&lang=js&"
export * from "./ComposerBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports